import AppFunction from "../../../../../core/helpers/app/AppFunction.js";


export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('Creation Date'),
                    type: 'custom-html',
                    key: 'creation_date',
                    modifier: (value) => {
                        return value ? new Date(value).toISOString().split('T')[0] : '';
                    }
                },

                {
                    title: this.$t('Number'),
                    key: 'number',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    headerClass: 'center',
                    modifier: (value) => {
                        if (value) {    
                            return `<div style="text-align: center;">
                                        <span style="font-weight: 900; font-size: 15px; ">${value}</span> 
                                    </div>`;
                        }
                    }
                },

                // 1 maritimo 2 terrestre 
                {
                   title: this.$t('Shipment_type'),
                    type: 'custom-html', // Or 'html' if it renders raw HTML
                    key: 'shipment_type',
                    isVisible: true,
                    headerClass: 'center',
                    ClassName: 'center', // You might not need this here if styling within the modifier
                    modifier: (value, row) => {
                        const shipmentType = row.shipment_type.toLowerCase() ?? null;
                        let imageUrl = ''; // Start with default
                        if (typeof shipmentType === 'string') {
                            if (shipmentType.startsWith('o')) {
                                imageUrl = AppFunction.getAppUrl('images/barco.jpg');
                            } else if (shipmentType.startsWith('t')) { // Use else if for mutually exclusive conditions
                                imageUrl = AppFunction.getAppUrl('images/camion.jpg');
                            }
                        }
                        return `<div style="display: flex; justify-content: center; align-items: center; height: 50%;">
                            <img src="${imageUrl}" alt="Shipment Type" style="max-width: 60%; max-height: 60px;">
                        </div>`;

                    },
                },
                {
                    title: this.$t('Loads'),
                    key: 'loads',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    headerClass: 'center',
                    modifier: (value) => {
                        if (value) {    
                            return `<div style="text-align: center;">
                                        <span style="font-size: 14px; ">${value}</span> 
                                    </div>`;
                        }
                    }
                },
                {
                    title: this.$t('country_of_origin'),
                    type: 'object',
                    key: 'country',
                    modifier: (value, _) => {
                        if (value) {
                            return value['name'];
                        }
                        return '';
                    }
                },


                {
                    title: this.$t('Supplier'),
                    modifier : (_) => {
                    return `class=text-center`
                },
                    key: 'contract_suppliers',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        if (value && value.length > 0) {
                            const contractSupplier = value[0];
                            if (contractSupplier.supplier_company) {  
                                return `<div">
                                        <span style="font-size: 14px; ">${contractSupplier.supplier_company.Second_Title}</span> 
                                    </div>`;
                            }
                        }
                    }
                },

                {
                    title: this.$t('Customer'),
                    key: 'contract_customer',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        if (value && value.length > 0) {
                            const contractCustomer = value[0];
                            if (contractCustomer.customer_company) {
                                return `<div>
                                        <span style="font-size: 14px; ">${contractCustomer.customer_company.Second_Title}</span> 
                                    </div>`;
                            }
                        }
                    }
                },

                {
                    title: this.$t('Products List'),
                    type: 'custom-html', 
                    key: 'products', // <-- Debe coincidir con el nombre de la relación en el modelo Contract
                    modifier: (productsArray) => {
                        if (!Array.isArray(productsArray) || productsArray.length === 0) {
                            return 'No products';
                        }

                        const productStrings = productsArray.map(product => {
                            const productName = product.ProductName || 'N/A';
                            const orgConv = product.OrganicConv || '';
                            const subCategory = product.subcategory_value || '';
                            const feature = product.Product_Feature_value || '';

                            return `${orgConv} ${subCategory} ${productName} ${feature}`;
                        });
                        const uniqueProductStrings = [...new Set(productStrings)];
                        const productListString = uniqueProductStrings.join('\n');
                        return `<span style="white-space: pre-line; text-align: left;">${productListString}</span>`;
                    }
                },

                {
                    title: this.$t('Logistic Coordinator'),
                    type: 'object',
                    key: 'logistic_user',
                    modifier: (value, _) => {
                        if (value) {
                            return value['first_name'] + ' ' + value['last_name'];
                        }
                        return '';
                    }
                },

                {
                    title: this.$t('Versions'),
                    key: 'versions_count',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    headerClass: 'center',
                    modifier: (value) => {
                        if (value) {    
                            return `<div style="text-align: center;">
                                        <span style="font-size: 14px; ">${value - 1}</span> 
                                    </div>`;
                        }
                    }
                },


                {
                    title: this.$t('Approved & ready for Logistics'),
                    type: 'text',
                    key: 'approve_contract',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        const STATUS_CONFIG = {
                            1: { icon: 'fas fa-check', color: 'success' },
                            0: { icon: 'fas fa-stop', color: 'danger' },
                            2: { icon: 'fas fa-exclamation-triangle', color: 'warning' },
                        };
                        const status = STATUS_CONFIG[value];
                        const color = status?.color ?? '';
                        const icon = status?.icon ?? '';
                        
                        return `<div style="text-align: center;">
                                    <span class="badge-status badge-sm badge-pill badge-${color ?? 'warning'}"> 
                                        <i class="${icon}"></i>
                                    </span>
                                </div>`;
                    }
                },
                {
                    title: this.$t('Status'),
                    type: 'custom-html',
                    key: 'status',
                    isVisible: true,
                    modifier: (value) => {        
                        const STATUS_BADGE_CONFIG = {
                            'Active': {
                                colorClass: 'success-badge', 
                                textKey: 'Active'            
                            },
                            'Cancelled': {
                                colorClass: 'danger-badge',
                                textKey: 'Cancelled'
                            },
                            'Pending' : {
                                colorClass: 'warning-badge',
                                textKey: 'Pending'
                            },
                            'default': {
                                colorClass: 'info-badge',  
                                textKey: 'Finished' 
                            }
                        };

                        if (value) {
                            const statusConfig = STATUS_BADGE_CONFIG[value] || STATUS_BADGE_CONFIG.default;
                            return `<span class="professional-badge professional-badge-${statusConfig.colorClass}">
                                        ${this.$t(statusConfig.textKey)}
                                    </span>`;
                        }
                    return '';
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
                modifier : (_) => {
                    return `class=text-center`
                }
            }
        }
    },
}